import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VDialog,
    {
      attrs: {
        value: true,
        persistent: "",
        "no-click-animation": "",
        "max-width": "620"
      }
    },
    [
      _c(
        VCard,
        [
          _c(VCardTitle, { staticClass: "headline" }, [
            _vm._v("Admin Panel is being retired")
          ]),
          _c(
            VCardText,
            [
              _c("p", [
                _vm._v("\n        Everything you do for "),
                _c("strong", [_vm._v(_vm._s(_vm.site.name))]),
                _vm._v(" now lives in Centric.\n      ")
              ]),
              _vm.canRequest
                ? [
                    _c("p", [
                      _vm._v(
                        "\n          If something is missing from Centric let us know.\n        "
                      )
                    ]),
                    _c(
                      VForm,
                      { ref: "form" },
                      [
                        _c(VTextarea, {
                          attrs: {
                            outline: "",
                            "auto-grow": "",
                            rows: "3",
                            label: "(optional)"
                          },
                          model: {
                            value: _vm.reason,
                            callback: function($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            VCardActions,
            [
              _c(
                VBtn,
                {
                  attrs: {
                    flat: "",
                    href: _vm.centricSiteURL,
                    target: "_blank"
                  }
                },
                [_vm._v("Open in Centric")]
              ),
              _c(VSpacer),
              _vm.canRequest
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary", loading: _vm.submitting },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("\n        Continue to Admin Panel\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }